.h2Base() {
  font-size: 20px;
  font-style: normal;
  font-weight: normal;
  line-height: 27px;
}

.h1 {
  font-size: 21px;
  font-weight: bold;
  line-height: 34px;
}

.h2 {
  .h2Base();
}

.h3 {
  .text-subtitle-l();
}

.h4 {
  .text-title-h3();
}

.pageTitle {
  .h2Base();

  position: relative;

  display: flex;
  flex-direction: column;
  justify-content: center;
}

.semiBold {
  font-weight: 600;

  &.capitalize {
    text-transform: capitalize;
  }
}

.bold {
  font-weight: bold;
}

.headSubTitle {
  .text-subtitle-m();

  margin-left: 10px;

  color: var(--x-color-text-secondary-darker);
}
